import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import toast from "react-hot-toast";

import ProgramDetail from "./Components/ProgramDetail";
import ProgramsList from "./Components/ProgramsList";
import SuccessPage from "./Components/SuccessPage";
import Logout from "../../common/Logout";
import PaddedContentArea from "../../common/PaddedContentArea";
import CloseButton from "../../common/CloseButton";
import CustomButton from "../../common/CustomButton";
import CustomModalWrapper from "../../common/CustomModalV2/wrapper";
import SuccessPagePromo from "./Components/SuccessPagePromo";
import WorkoutPlanModal from "./Components/WorkoutPlanModal";

import { CreatePurchaseUsingCoupon } from "../../redux/v2/plan/actions";
import { GetPrograms, GetSuggestedPrograms2 } from "../../redux/v2/program/actions";
import { GetWholeWorkoutByProgram } from "../../redux/v2/workout/actions";
import {
    GetAllWorkOutHistories, GetWorkOutHistory, GetAllWorkOutHistoriesWithArchived,
    GetSelectionHistory, EmailInvitationRegistered, LoadAccountDetails,
} from "../../redux/v2/user/actions";
import { ShowModal, SetModalProperties } from "../../redux/v2/utils/actions";

import { ScreenType } from "../../utils/breakpoints";
import { delay } from "../../utils";
import { callSocket } from "../../utils/socket";
import { checkIfUsingMobileApp } from "../../utils/userResource";
import { removeBRGPatientCookie } from "../../utils/cookie";

import "./style.css";
import "../home/style.css";

function OnBoarding(props) {
    const programID = new URLSearchParams(window.location.search).get("program");

    const location = useLocation();
    const navigate = useNavigate();
    const screenSize = ScreenType(useMediaQuery);

    const { programIsFull } = props;
    const { account, invitationDetails } = props.User;
    const { programs, suggestedPrograms } = props.Program;

    const [selectedProgram, setSelectedProgram] = useState(null);
    const [addedProgram, setAddedProgram] = useState([]);
    const [slide, setSlide] = useState(false);
    const [delaySlide, setDelay] = useState(null);
    const [syncedPrograms, setSyncedPrograms] = useState([]);

    const onboardingDetail = account?.onboardingDetails?.[account?.onboardingDetails?.length - 1];
    const programsInWP = onboardingDetail?.programs?.split(",");
    const isSlotAvailableInWP = programsInWP?.length < 3;

    const isInside = location.pathname.includes("/programs");
    const useSlide = true;

    const nextProceess = async () => {

        if (addedProgram.length == 0) {
            localStorage.setItem("skip-program-selection", 1);
        }

        if (account?.user?.company) {
            navigate("/");
            props.ShowModal(false);
        } else if (invitationDetails?.eventID) {
            const toastId = toast.loading("Setting up Free Trial Account...");
            const res = await props.CreatePurchaseUsingCoupon("14DFT");
            if (res.status == 200) {
                await props.LoadAccountDetails();
                if (invitationDetails?.signupType == "brgpatient") {
                    props.EmailInvitationRegistered(invitationDetails?.eventID);
                } else if (invitationDetails?.signupType == "therapistinvite") {
                }

                removeBRGPatientCookie();

                toast.dismiss(toastId);

                props.SetModalProperties({
                    id: "success-page-promo-modal",
                    isShow: true,
                    title: "",
                    height: "100%",
                    body: <>
                        <SuccessPagePromo close={() => {
                            navigate("/");
                            props.SetModalProperties({
                                isShow: false,
                                title: "",
                                height: "0%",
                                body: <>
                                </>,
                                actions: [],
                                showCloseButton: false,
                            });
                        }} />
                    </>,
                    actions: [],
                    showCloseButton: false,
                });
            } else {
                toast.error("Failed to setup Free Trial Account!", {
                    id: toastId,
                });
            }

        } else {
            const isUsingMobileApp = checkIfUsingMobileApp();

            if (isUsingMobileApp) {
                callSocket("/interact-native-component", { type: "screens", subtype: "show-billing" });
            } else {
                navigate("/choose-plan");
            }
            props.ShowModal(false);

        }


    };

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });

        props.GetPrograms();
        props.GetSuggestedPrograms2();

        props.GetWorkOutHistory();
        props.GetAllWorkOutHistories();
        props.GetAllWorkOutHistoriesWithArchived();
        props.GetSelectionHistory();

    }, []);

    useEffect(() => {
        if (suggestedPrograms?.length && programs?.length) {
            const temp = suggestedPrograms.map((p) => {
                for (let x = 0; x < programs.length; x++) {
                    if (p.id == programs[x].id) {
                        const l = ["", "beginner", "moderate", "advanced"];
                        if ((p.level == 1 && programs[x].beginner) || (p.level == 2 && programs[x].moderate) || (p.level == 3 && programs[x].advanced)) {
                            return {
                                ...p,
                                ...programs[x],
                                info: programs[x][l[p.level]],
                            };
                        } else {
                            return {
                                ...p,
                                ...programs[x],
                                level: 0,
                            };
                        }
                    }
                }
            });

            setSyncedPrograms(temp);
        }
    }, [suggestedPrograms, programs, programs?.length]);

    useEffect(() => {
        if (syncedPrograms?.length > 0 && programID) {
            let tempSelected = syncedPrograms.filter((sp) => sp.id == programID);
            props.GetWholeWorkoutByProgram(tempSelected[0]?.id, tempSelected[0]?.level);
            clearTimeout(delaySlide);
            setSelectedProgram(tempSelected[0]);
            setSlide(true);
        }
    }, [syncedPrograms]);

    const isInPrograms = location.pathname.includes("/programs");

    return (
        <>
            <div id="onboarding-v2" className="content-area">
                {!isInside && <Logout showLogo showLogout={false} />}

                {!useSlide && !isInside && !account?.user?.selected_program && selectedProgram && (
                    <CloseButton
                        onClick={() => {
                            if (!selectedProgram) {
                                navigate("/");
                            } else {
                                setSelectedProgram(null);
                            }
                        }}
                    />
                )}

                <PaddedContentArea>
                    <>
                        {(useSlide || !selectedProgram) && (
                            <div id="onb-v2-programs">
                                <div id="onb-v2-header">
                                    <div id="onb-v2-header-wrapper">
                                        {!account?.user?.selected_program ? (
                                            <>
                                                <h4>WELCOME {account?.user?.first_name?.toUpperCase()}</h4>
                                                <body>To get started, choose at least one program. You can add more in the future.</body>
                                            </>
                                        ) : (
                                            <>
                                                {
                                                    (programIsFull && isInPrograms)
                                                        ? <>
                                                            <h4>You Already Have Three Programs!</h4>
                                                            <body>If you’d like to choose a different program, please remove one from your schedule to free up some space.</body>
                                                        </>
                                                        : <>
                                                            <h4>READY TO KEEP MOVING?</h4>
                                                            <body>Our goal is to get you moving three times a week.Choose a new program to add to your journey.</body>
                                                        </>
                                                }
                                            </>
                                        )}
                                    </div>
                                </div>

                                <ProgramsList
                                    programs={syncedPrograms}
                                    setSelectedProgram={(data) => {
                                        clearTimeout(delaySlide);
                                        setSelectedProgram(data);
                                        setSlide(true);
                                    }}
                                    screenSize={screenSize}
                                    addedProgram={addedProgram}
                                    programIsFull={programIsFull}
                                />
                            </div>
                        )}

                        {!useSlide && selectedProgram && (
                            <ProgramDetail
                                selectedProgram={selectedProgram}
                                setSelectedProgram={setSelectedProgram}
                                setAddedProgram={() => {
                                    setAddedProgram([...addedProgram, { ...selectedProgram, added: true }]);
                                    setSelectedProgram(null);
                                }}
                                screenSize={screenSize}
                                back={() => {
                                    if (!selectedProgram) {
                                        navigate("/");
                                    } else {
                                        setSelectedProgram(null);
                                    }
                                }}
                                postActionCallback={(data) => {
                                    if (data?.success) {
                                        if (isSlotAvailableInWP) {
                                            delay(() => {
                                                props.SetModalProperties({
                                                    showCloseButton: false,
                                                    isShow: true,
                                                    title: "",
                                                    height: "480px",
                                                    body: <WorkoutPlanModal selectedProgram={selectedProgram} />,
                                                    actions: [],
                                                });
                                            }, 1000);
                                        }
                                    }
                                }}
                            />
                        )}

                        {useSlide && (
                            <div id="slider-modal-div" style={{ top: slide ? "0" : "100%" }}>
                                <PaddedContentArea>
                                    <CloseButton
                                        onClick={() => {
                                            setSlide(false);
                                            delay(() => {
                                                setSelectedProgram(null);
                                            }, 300);
                                        }}
                                    />
                                    {selectedProgram && (
                                        <ProgramDetail
                                            selectedProgram={selectedProgram}
                                            setSelectedProgram={setSelectedProgram}
                                            setAddedProgram={() => {
                                                setAddedProgram([...addedProgram, { ...selectedProgram, added: true }]);
                                                setSlide(false);
                                                setDelay(
                                                    delay(() => {
                                                        setSelectedProgram(null);
                                                    }, 300)
                                                );
                                            }}
                                            screenSize={screenSize}
                                            back={() => {
                                                setSlide(false);
                                                setDelay(
                                                    delay(() => {
                                                        setSelectedProgram(null);
                                                    }, 300)
                                                );
                                            }}
                                            postActionCallback={(data) => {
                                                if (data?.success) {
                                                    if (isSlotAvailableInWP) {
                                                        delay(() => {
                                                            props.SetModalProperties({
                                                                showCloseButton: false,
                                                                isShow: true,
                                                                title: "",
                                                                height: "480px",
                                                                body: <WorkoutPlanModal selectedProgram={selectedProgram} />,
                                                                actions: [],
                                                            });
                                                        }, 1000);
                                                    }
                                                }
                                            }}
                                        />
                                    )}
                                </PaddedContentArea>
                            </div>
                        )}
                    </>
                </PaddedContentArea>
            </div >

            {(location.pathname == "/program-introduction" || location.pathname?.includes("/user-onboarding") || location.pathname?.includes("/patient-invite")) && (
                <div id="pi-v2-sticky-footer">
                    {screenSize != "xl" &&
                        (addedProgram.length > 0 ? (
                            <div
                                id="pi-v2-mobile-skip"
                                style={{ backgroundColor: "#d37536" }}
                                onClick={() => {
                                    nextProceess();
                                }}
                            >
                                <h4>Get Started</h4>
                            </div>
                        ) : (
                            <div id="pi-v2-mobile-skip">
                                <CustomButton
                                    isPrimary={false}
                                    onClick={() => {
                                        nextProceess();
                                    }}
                                >
                                    Skip
                                </CustomButton>
                            </div>
                        ))}

                    {screenSize == "xl" && (
                        <div id="pi-v2-desktop-skip" style={{ justifyContent: addedProgram > 0 ? "center" : "flex-end", paddingRight: addedProgram > 0 ? 0 : "50px" }}>
                            <CustomButton
                                isPrimary={addedProgram.length > 0}
                                onClick={() => {
                                    nextProceess();
                                }}
                            >
                                {addedProgram.length > 0 ? "Get Started" : "Skip"}
                            </CustomButton>
                        </div>
                    )}
                </div>
            )
            }

            <CustomModalWrapper />

        </>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
    Program: state.Program,
});

export default connect(mapStateToProps, {
    GetPrograms,
    GetSuggestedPrograms2,
    GetWholeWorkoutByProgram,
    GetWorkOutHistory,
    GetAllWorkOutHistories,
    GetAllWorkOutHistoriesWithArchived,
    GetSelectionHistory,
    ShowModal,
    SetModalProperties,
    CreatePurchaseUsingCoupon,
    EmailInvitationRegistered,
    LoadAccountDetails,
})(OnBoarding);
